import { createPropertySelectors } from "@ngxs/store";
import { ASSEMBLIES_STATE_TOKEN, AssembliesStateModel } from "./state";

export class AssembliesSelectors {
  static slices = createPropertySelectors<AssembliesStateModel>(ASSEMBLIES_STATE_TOKEN);
}
